import { Button } from "antd";
import { FaArrowRight } from "react-icons/fa";

export default function SubmitButton({
  loading = false,
  disabled = false,
  text = "Submit",
  icon = <FaArrowRight />,
  className = "",
  ...rest
}) {
  return (
    <Button
      type="primary"
      htmlType="submit"
      size="large"
      loading={loading}
      disabled={disabled}
      className="login-regictation-submit-btn"
      {...rest}
    >
      {text} {icon && icon}
    </Button>
  );
}
